/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, lazy, Suspense} from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import Dashboard from "./Pages/Dashboard/Dashboard";
// import History from "./Pages/History/History";
// import Settings from "./Pages/Settings/Settings";
import Login from "./Pages/Authentication/Login";
import Register from "./Pages/Authentication/Register";
import ForgotPassword from "./Pages/Authentication/ForgotPassword";
// import PatientProfile from "./Pages/Patients/PatientProfile";
import AddPatientLeads from "./Pages/Ordering/AddPatientLeads";
import Logout from "./Pages/Authentication/Logout";
import { ProtectedRoute } from "./Utils/ProtectedRoute";
import { ToastContainer } from "react-toastify";
import OrderComplete from "./Pages/Ordering/Components/OrderComplete";
// import OrderStatus from "./Pages/Ordering/Components/OrderStatus";
import ConfirmOrderByPatient from "./Pages/Helpers/ConfirmOrderParent/ConfirmOrderByPatient";
import ConfirmOrderByParentLP from "./Pages/Helpers/ConfirmOrderParent/ConfirmOrderByParentLP";
// import { poolData } from "./Configs/AWS/config";
// import storage from "redux-persist/lib/storage";
// import PatientHistory from "./Pages/Patients/PatientHistory";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "./Store/Hooks";
import { selectTempState } from "./Store/TempStore/selectors";
import { tempActions } from "./Store/TempStore/reducer";
import PostRegisterOption from "./Pages/Authentication/Components/PostRegisterOptions";
import OrderKiddo from "./Pages/Ordering/Components/OrderKiddo";
// import LandingPageCreateOrder from "./Pages/LandingPageOrder/LandingPageCreateOrder";
import { providerActions } from "./Store/Provider/reducer";
import GoogleContactUs from "./Pages/GoogleContact/GoogleContactUs";
import { signOut } from "aws-amplify/auth";
import { MakeAmplifyConfig } from "./Configs/AWS/config";
import { selectIsProviderLoggedIn } from "./Store/Provider/selectors";
import { Amplify } from "aws-amplify";
const LazyCompLandingPageCreateOrder = lazy(() => import("./Pages/LandingPageOrder/LandingPageCreateOrder"));

const App = () => {
  const dispatch = useAppDispatch()
  const isLoggedIn = useAppSelector(selectIsProviderLoggedIn);
  const tempState = useAppSelector(selectTempState);
  Amplify.configure(MakeAmplifyConfig(isLoggedIn));
  
  useEffect(() => {
    let session = sessionStorage.getItem("register");
    if (session === null || session === undefined) {
      dispatch(providerActions.logout());
      signOut();
      localStorage.clear();
    }
    setTimeout(() => {
      sessionStorage.setItem("register", "1");
    }, 5000);
  }, []);

  (() => {
    if (tempState.lastUpdate) {
      let startTime = moment(tempState.lastUpdate);
      let endTime = moment();
      let diff = endTime.diff(startTime, "hours", true);
      if (diff > 12) {
        dispatch(tempActions.resetTemp());
      }
    }
  })();

  return (
    <>
      <main className="main">
        <div className="page-wrapper">
          <React.Fragment>
            <BrowserRouter>
              <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                  <Route path='*' element={<Register />} />
                  <Route path="/" element={<Login />}></Route>
                  <Route path="/login" element={<Login />}></Route>
                  <Route path="/contact-us" element={<GoogleContactUs />}></Route>
                  <Route path="/confirm-order/:id?" element={<ConfirmOrderByPatient />}></Route>
                  <Route path="/confirm-order-lp/:id?" element={<ConfirmOrderByParentLP />}></Route>
                  <Route path="/kiddo-order/:providerTag?" element={<LazyCompLandingPageCreateOrder />}></Route>
                  <Route path="/forgotpassword" element={<ForgotPassword />}></Route>
                  <Route path="/signup" element={<Register />}></Route>
                  <Route path="/account-setup-complete" element={<PostRegisterOption />}></Route>
                  <Route path="/logout" element={<ProtectedRoute isSideBar={true}><Logout /></ProtectedRoute>}></Route>
                  <Route path="/dashboard" element={<ProtectedRoute isSideBar={true}><Dashboard /></ProtectedRoute>}></Route>
                  {/* <Route path="/history" element={<ProtectedRoute isSideBar={true}><History /></ProtectedRoute>}></Route> */}
                  <Route path="/order" element={<ProtectedRoute isSideBar={true}><OrderKiddo /></ProtectedRoute>}></Route>
                  <Route path="/order-complete" element={<ProtectedRoute isSideBar={true}><OrderComplete /></ProtectedRoute>}></Route>
                  {/* <Route path="/order-status" element={<ProtectedRoute isSideBar={true}><OrderStatus /></ProtectedRoute>}></Route> */}
                  {/* <Route path="/settings" element={<ProtectedRoute isSideBar={true}><Settings /></ProtectedRoute>}></Route> */}
                  {/* <Route path="/patientprofile/:id" element={<ProtectedRoute isSideBar={true}><PatientProfile /></ProtectedRoute>}></Route> */}
                  {/* <Route path="/patienthistory/:id" element={<ProtectedRoute isSideBar={true}><PatientHistory /></ProtectedRoute>}></Route> */}
                  <Route path="/addpatientleads" element={<ProtectedRoute isSideBar={false}><AddPatientLeads /></ProtectedRoute>}></Route>
                </Routes>
              </Suspense>
            </BrowserRouter>
          </React.Fragment>
        </div>
      </main>
      <ToastContainer
        position="top-center"
        autoClose={8000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

export default App;
